import { createApp, ref } from 'vue';
import ContextMenu from '🔗/components/ui/ContextMenu.vue';

export default {
    mounted(el, binding) {
        // один ref на все апдейты
        const itemsRef = ref(binding.value);

        const handler = (e) => {
            e.preventDefault();

            const container = document.createElement('div');
            container.style.position = 'fixed';

            document.body.appendChild(container);

            const app = createApp(ContextMenu, {
                event: e,
                items: itemsRef,
                onClose: () => {
                    app.unmount();
                    container.remove();
                },
            });

            app.mount(container);
        };

        el.__contextMenuHandler__ = handler;
        el.__contextMenuItems__ = itemsRef;

        el.addEventListener('contextmenu', handler);
    },

    updated(el, binding) {
        // синхронизируем изменения
        if (el.__contextMenuItems__) {
            el.__contextMenuItems__.value = binding.value;
        }
    },

    unmounted(el) {
        if (el.__contextMenuHandler__) {
            el.removeEventListener('contextmenu', el.__contextMenuHandler__);
            delete el.__contextMenuHandler__;
            delete el.__contextMenuItems__;
        }
    },
};
